import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

const retryCount = 3;
const retryDelay = 1500;

export function refreshTokenRetryInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(OAuthService);

   if (req.url === authService.tokenEndpoint) {
    return next(req).pipe(
      retry({
        count: retryCount,
        delay: retryDelay
      })
    );
  } else {
    return next(req);
  }
}
